import React from "react";

export function StatusBadge({ status }) {
  const cls = status === "Completado"
    ? "bg-green-500/15 text-green-300 border-green-500/30"
    : status === "En Proceso"
    ? "bg-cyan-500/15 text-cyan-300 border-cyan-500/30"
    : status === "Pago Incompleto"
    ? "bg-orange-500/15 text-orange-300 border-orange-500/30"
    : status === "Rechazado"
    ? "bg-red-500/15 text-red-300 border-red-500/30"
    : status === "Reajuste Rechazado"
    ? "bg-red-500/10 text-red-200 border-red-500/40"
    : "bg-yellow-500/15 text-yellow-300 border-yellow-500/30";
  return <span className={`px-3 py-1 rounded-full text-xs font-bold tracking-wide border ${cls}`}>{status}</span>;
}

export function UserStatusBadge({ status }) {
  const map = {
    active: { cls: "bg-green-500/20 text-green-300 border-green-500/40", label: "Activo" },
    suspended: { cls: "bg-yellow-500/20 text-yellow-300 border-yellow-500/40", label: "Suspendido" },
    blocked: { cls: "bg-red-500/20 text-red-300 border-red-500/40", label: "Bloqueado" },
  };
  const { cls, label } = map[status] || map.active;
  return <span className={`px-2 py-0.5 rounded-full border text-[10px] font-bold ${cls}`}>{label}</span>;
}

export function WithdrawalStatusBadge({ status }) {
  const cls = status === "Realizado"
    ? "bg-green-500/15 text-green-300 border-green-500/30"
    : status === "En Proceso"
    ? "bg-cyan-500/15 text-cyan-300 border-cyan-500/30"
    : status === "Rechazado"
    ? "bg-red-500/15 text-red-300 border-red-500/30"
    : "bg-yellow-500/15 text-yellow-300 border-yellow-500/30";
  return <span className={`px-3 py-1 rounded-full text-xs font-bold tracking-wide border ${cls}`}>{status}</span>;
}
